import { FC } from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import useAuth from '../hooks/useAuth'
import { UserRole } from '../types/generalType'

type IProps = {
  allowedRoles: UserRole[]
}

const ProtectedRoute: FC<IProps> = ({ allowedRoles }) => {
  const { user } = useAuth()

  return user?.role?.find((role: UserRole) => allowedRoles?.includes(role)) ? (
    <Outlet />
  ) : (
    <Navigate to='/Auth' />
  )
}

export default ProtectedRoute
